import {
  Typography,
  Box,
  Alert
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { getHeader } from "../service/auth";
import { useNavigate } from "react-router-dom";
import QuestList from "../components/QuestList";
import LoadingState from "../components/LoadingState";
import EmptyState from "../components/EmptyState";
import { Assignment as AssignmentIcon } from '@mui/icons-material';
import themeNutriFast from "../styles/NutriFastColors";
import useRetryableApi from "../hooks/useRetryableApi";
import PageTransition from "../components/PageTransition";
export default function Dashboard() {
  const headers = getHeader();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  let navigate = useNavigate();
  const { executeWithRetry, getErrorMessage, isRetrying } = useRetryableApi();

  const handleChangePage = (page, quest) => {
    if (page) navigate(page, { state: quest });
  };

  useEffect(() => {
    const fetchQuestionnaires = async () => {
      setLoading(true);
      setError(null);
      
      await executeWithRetry(
        () => axios.get(process.env.REACT_APP_QUESTIONNAIRE, { headers }),
        ({ data }) => {
          setList(data);
          setLoading(false);
        },
        (error, attemptCount) => {
          setError(getErrorMessage(error, attemptCount));
          setLoading(false);
        }
      );
    };

    fetchQuestionnaires();
  }, []); // Tableau vide pour exécution unique au montage

  // Fonction helper pour vérifier si la liste est complètement vide
  const isEmpty = !list.newTab?.length && !list.en_cours?.length && !list.valide?.length;

  return (
    <PageTransition>
      <h2 style={{color:themeNutriFast.palette.primary.dark}} className='title-dashbord'>Questionnaires</h2>
      
      {loading && (
        <LoadingState 
          message={isRetrying ? "Nouvelle tentative de connexion..." : "Chargement des questionnaires..."} 
        />
      )}

      {error && (
        <Box sx={{ mt: 2, mb: 2 }}>
          <Alert severity="error">
            {error}
          </Alert>
        </Box>
      )}

      {!loading && !error && isEmpty && (
        <EmptyState
          title="Aucun questionnaire disponible"
          description="Vos questionnaires apparaîtront ici une fois qu'ils vous seront assignés."
          icon={<AssignmentIcon sx={{ fontSize: 64 }} />}
        />
      )}

      {!loading && !error && !isEmpty && (
        <>
          {list.newTab && list.newTab.length > 0 && (
            <>
              <Typography variant="h6" gutterBottom className="item-title-dashbord">
                Nouveau
              </Typography>
              <QuestList list={list.newTab} handleChangePage={handleChangePage} />
            </>
          )}
          {list.en_cours && list.en_cours.length > 0 && (
            <>
              <Typography variant="h6" gutterBottom className="item-title-dashbord">
                En cours
              </Typography>
              <QuestList list={list.en_cours} handleChangePage={handleChangePage} />
            </>
          )}
          {list.valide && list.valide.length > 0 && (
            <>
              <Typography variant="h6" gutterBottom className="item-title-dashbord">
                Validé
              </Typography>
              <QuestList list={list.valide} handleChangePage={handleChangePage} />
            </>
          )}
        </>
      )}
    </PageTransition>
  );
}
